module.exports = __webpack_public_path__ + "static/media/quality_en.0b21a30c.png";